import { Card, message, theme } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Permission, type CreateCatalogoDto, type UpdateCatalogoDto } from '@aid/shared';
import { useHasPermission } from '../../auth/useHasPermission';
import { PageHeader } from '../../components/PageHeader';
import { useCreateCatalogoAdmin } from './api/useCatalogosAdmin';
import { CatalogoForm } from './components/CatalogoForm';

export function CatalogoCreatePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const categoryCode = searchParams.get('category') ?? undefined;
  const createCatalogo = useCreateCatalogoAdmin();
  const hasPermission = useHasPermission(Permission.CATALOGOS_CREATE);
  const { token } = theme.useToken();

  if (!hasPermission) {
    return <div>No tenés permiso para crear registros de catálogo.</div>;
  }

  const handleSubmit = async (values: CreateCatalogoDto | UpdateCatalogoDto) => {
    const { key, value, category, parent, active } = values;
    if (typeof key !== 'string' || typeof value !== 'string' || typeof category !== 'string') {
      return;
    }
    const payload: CreateCatalogoDto = { key, value, category, parent, active };
    try {
      await createCatalogo.mutateAsync(payload);
      message.success('Registro creado correctamente');
      navigate(`/catalogos/category/${encodeURIComponent(category)}`);
    } catch {
      message.error('No se pudo crear el registro');
    }
  };

  return (
    <div>
      <PageHeader title="Nuevo registro" subtitle="Agregá un valor a una categoría existente." />
      <Card
        style={{
          borderRadius: 12,
          border: `1px solid ${token.colorBorderSecondary}`,
          boxShadow: token.boxShadow,
        }}
      >
        <CatalogoForm
          mode="create"
          categoryCode={categoryCode}
          onSubmit={handleSubmit}
          loading={createCatalogo.isPending}
        />
      </Card>
    </div>
  );
}
